import React from 'react'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { useState } from 'react'
import "../../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/exam-pages-styles/MockExamLanding.css";
import { useNavigate } from 'react-router-dom';


const MockExamLanding = () => {
  const navigate = useNavigate();
  const [extraTime, setExtraTime] = useState(false);

  const handleToggleChange = () => {
    setExtraTime(!extraTime);
  };

  const handleNextClick = () => {
    alert("Navigating to the first question");
  };

  return (
    <div>
      <Navbar expand="lg" className="bg-body-primary">
        <Container>
          <Navbar.Brand href="#home"> PassMedicine</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown title="Options" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.2">
                  Save and Exit
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Abandon and Exit
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="exam-container">
        <header className="exam-header"></header>

        <main className="exam-content">
          <h1>Applied Knowledge Test - Mock Exam A</h1>

          <div className="exam-instructions">
            <p>
              Welcome to the mock exam. This aims to recreate what you will
              experience in the real exam, in terms of both questions and user
              experience.
            </p>

            <p>
              After the mock exam you'll be able to compare your performance to
              other users who are preparing for the same exam.
            </p>

            <div className="toggle-container">
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={extraTime}
                  onChange={handleToggleChange}
                />
                <span className="slider round"></span>
              </label>
              <span className="toggle-label">
                I am entitled to an extra 25% time in examinations
              </span>
            </div>

            <p>
              Click <strong>Next</strong> in the bottom right hand corner to
              continue.
            </p>
          </div>
        </main>

        <footer className="exam-footer">
        <button className="next-button">Next →</button>
      </footer>
      </div>
    </div>
  );
};

    export default MockExamLanding;